import { TApiResponseData } from 'src/services/apiTypes';

// 프로토콜 버전 관리
export const MESSAGE_PROTOCOL_VERSION = '1.1.0';
export const MIN_SUPPORTED_VERSION = '1.0.0';

// 메시지 타입 상수
export const MESSAGE_TYPES = {
  AUTH_VERIFICATION: 'AUTH_VERIFICATION',
  CRAVING_CONTENTS: 'CRAVING_CONTENTS',
  ALERT: 'ALERT',
  DEVICE_TOKEN: 'DEVICE_TOKEN',
  NAVIGATION_GUARD: 'NAVIGATION_GUARD',
  NAVIGATE: 'NAVIGATE',
  LANGUAGE_CHANGE: 'LANGUAGE_CHANGE',
  OPEN_STORE: 'OPEN_STORE',
} as const;

// 기본 메시지 인터페이스 (프로토콜 버전 포함)
export interface BaseMessage {
  type: string;
  version?: string;
}

// 본인인증
type AuthVerificationMessage = {
  type: typeof MESSAGE_TYPES.AUTH_VERIFICATION;
  payload: {
    verifyUrl: string;
  };
};

// 갈망 SOS
type CravingContentsMessage = {
  type: typeof MESSAGE_TYPES.CRAVING_CONTENTS;
  payload: {
    title: string;
    contentsUrl: string;
  };
};

// 알림창 (AelrtMessage 오타 수정 + 하위 호환 별칭)
type AlertMessage = {
  type: typeof MESSAGE_TYPES.ALERT;
  payload: {
    isOpen: boolean;
  };
};

// @MX:NOTE: [AUTO] AelrtMessage -> AlertMessage 오타 수정, 하위 호환을 위한 별칭 유지
// @MX:SPEC: SPEC-WEBVIEW-001
type AelrtMessage = AlertMessage;

// 디바이스 토큰 api 요청
type DeviceTokenRequestMessage = {
  type: typeof MESSAGE_TYPES.DEVICE_TOKEN;
};

// 디바이스 토큰 app 응답
type DeviceTokenResponseMessage = {
  type: typeof MESSAGE_TYPES.DEVICE_TOKEN;
  payload: {
    deviceToken: string;
  };
};

// 백버튼 방지
type NavigationGuardMessage = {
  type: typeof MESSAGE_TYPES.NAVIGATION_GUARD;
  payload: {
    preventNavigation: boolean;
  };
};

// 네비게이트 메시지 (App -> Web)
type NavigateMessage = {
  type: typeof MESSAGE_TYPES.NAVIGATE;
  payload: {
    target: 'mission' | 'missionHistory' | 'nicojini' | 'diary' | 'craving';
  };
};

// 언어 변경 메시지 (Web -> App)
type LanguageChangeMessage = {
  type: typeof MESSAGE_TYPES.LANGUAGE_CHANGE;
  payload: {
    language: string;
  };
};

// 스토어 이동 메시지 (Web -> App)
type OpenStoreMessage = {
  type: typeof MESSAGE_TYPES.OPEN_STORE;
  payload: {
    storeUrl: string;
  };
};

// 보내는 메시지 타입
export type SendMessageType =
  | AuthVerificationMessage
  | CravingContentsMessage
  | AlertMessage
  | NavigationGuardMessage
  | DeviceTokenRequestMessage
  | LanguageChangeMessage
  | OpenStoreMessage;

// 받는 메시지 타입
export type ReceiveMessageType =
  | TApiResponseData<null>
  | AlertMessage
  | DeviceTokenResponseMessage
  | NavigateMessage;

// 하위 호환을 위한 타입 내보내기
export type { AelrtMessage, AlertMessage, LanguageChangeMessage, NavigateMessage };
